<template>
<div>
    <div class="col-md-12" v-if="Object.keys(postAnestecia).length > 0">
        <div class="row mt-2">
            <div class="my-1 px-0">
                <div class="d-md-flex text-xs">
                    <div class="col-lg-10 col-md-10 bg-main text-white text-center rounded p-2">
                        <span class="fw-bold">REPORTE DE POST ANESTESIA</span>
                    </div>
                    <div class="col-xl-2 col-lg-2 col-md-2 h-100 px-1">
                            <button type="button" class="btn btn-outline-success w-100" @click="mtdViewPdf()">
                                <i class="fas fa-file-pdf"></i> Exportar
                            </button>
                        </div>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="panel-border my-1">
                <!-- STAFF -->
                <div class="d-md-flex gap-1 p-2 mt-2">
                    <div class="col-md-4 mb-2 align-left" v-for="(item2, index) in postAnestecia.staff" :key="index">
                        <div class="d-md-flex">
                            <label :for="'input2' + index" class="text-xs color-main fw-bold">{{ item2.label
                                    }}</label>
                            <div class="px-1 w-100">
                                <input type="text" v-model="item2.value" disabled class="form-control form-control-input form-control-sm" :id="'input2' + index" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col text-center fw-bold py-2 div-title">
                        <span class="text-uppercase">Evaluación a su ingreso</span>
                    </div>
                </div>
                <div class="d-md-flex gap-1">
                    <div class="col-lg-4 col-md-4 col-sm-12 mb-2 align-left">
                        <div class="">
                            <label for="hora" class="text-xs color-main fw-bold mb-2">Hora</label>
                            <div class="px-1 w-100">
                                <input type="time" v-model="postAnestecia.hour" class="form-control form-control-input form-control-sm" id="hora" disabled />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 mb-2 align-left">
                        <div class="">
                            <label for="text" class="text-xs color-main fw-bold mb-2">Enfermera</label>
                            <div class="px-1 w-100">
                                <input type="text" v-model="cpNurse" class="form-control form-control-input form-control-sm" id="hora" disabled />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-12 mb-2 align-left">
                        <div class="">
                            <label for="text" class="text-xs color-main fw-bold mb-2">CEP</label>
                            <div class="px-1 w-100">
                                <input type="text" v-model="cpNurseCode" class="form-control form-control-input form-control-sm" id="hora" disabled />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- scrores -->
                <div class="d-md-flex flex-wrap mt-2">
                    <div class="col-lg-4 col-md-6 px-1 mb-2">
                        <!-- score_aldrete -->
                        <div class="row px-2 text-center">
                            <div class="py-2 px-3">
                                <div class="bg-main">
                                    <span class="text-white fw-semibold ">SCORE ALDRETE</span>
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex p-3">
                            <div class="col-12" v-for="(item, index) in postAnestecia.score_aldrete" :key="index">
                                <div class="d-md-flex">
                                    <div class="col-md-6 align-left">
                                        <span class="fw-semibold color-main text-xs">{{ item.label }}</span>
                                    </div>
                                    <div class="col-md-6 d-flex justify-content-center">
                                        <span class="text xs">{{ item.value }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 my-2">
                                <div class="d-md-flex">
                                    <div class="col-lg-6 col-md-6 align-left">
                                        <label for="totalsa" class="fw-bold color-main ">Total: </label>
                                    </div>
                                    <div class="col-lg-6 col-md-6">
                                        <input class="form-control form-control-sm form-control-input" type="text" name="total" id="totalsa" v-model="cpTotalScoreAldrete" disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- score_aldrete -->
                        <div class="row px-2 text-center">
                            <div class="py-2 px-3">
                                <div class="bg-main">
                                    <span class="text-white fw-semibold ">SCORE STEWARD</span>
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex p-1 pt-0">
                            <div class="col-12" v-for="(item, index) in postAnestecia.score_steward">
                                <div class="d-md-flex px-2">
                                    <div class="col-md-6 align-left">
                                        <span class="fw-semibold color-main text-xs">{{ item.label }}</span>
                                    </div>
                                    <div class="col-md-6 d-flex justify-content-center">
                                        <span class="text xs">{{ item.value }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 my-2">
                                <div class="d-md-flex">
                                    <div class="col-lg-6 col-md-6 align-left">
                                        <label for="total" class="fw-bold color-main ">Total: </label>
                                    </div>
                                    <div class="col-lg-6 col-md-6">
                                        <input class="form-control form-control-sm form-control-input" type="text" name="total" id="total" v-model="cpTotalSteward" disabled>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- score_bromage -->
                        <div class="row px-2 text-center">
                            <div class="py-2 px-3">
                                <div class="bg-main">
                                    <span class="text-white fw-semibold ">SCORE BROMAGE</span>
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex p-1">
                            <div class="col-12" v-for="(item, index) in postAnestecia.score_bromage">
                                <div class="d-md-flex">
                                    <div class="col-md-6 align-left">
                                        <span class="fw-semibold color-main">{{ item.label }}</span>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-inline mx-1">
                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input" type="radio" disabled :name="'valorsb' + index" :id="'d1sb' + index" :value="0" v-model="item.value">
                                                <label class="form-check-label text-md" :for="'d1sb' + index">0</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input" type="radio" disabled :name="'valorsb' + index" :id="'d2sb' + index" :value="1" v-model="item.value">
                                                <label class="form-check-label text-md" :for="'d2sb' + index">1</label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <input class="form-check-input" type="radio" disabled :name="'valorsb' + index" :id="'d3sb' + index" :value="2" v-model="item.value">
                                                <label class="form-check-label text-md" :for="'d3sb' + index">2</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <!-- sintomas -->
                    <div class="col-lg-4 col-md-6 px-1 mb-3">
                        <div class="row px-2 text-center">
                            <div class="py-2 px-3">
                                <div class="bg-main">
                                    <span class="text-white fw-semibold">OTROS SIGNOS / SINTOMAS</span>
                                </div>
                            </div>
                        </div>
                        <div class="row d-flex px-2 pt-0">
                            <div v-for="(item, index) in postAnestecia.signs" :key="index" class="custom-control px-2 custom-checkbox color-main align-left px-2 col-sm-12 col-md-6 col-xl-12 col-lg-6 mt-1">
                                <div class="px-2">
                                    <input type="checkbox" disabled class="custom-control-input visually-hidden" :id="'checkbox' + index" v-model="item.value">
                                    <label class="custom-control-label fw-semibold" :for="'checkbox' + index">
                                        <span class="checkmark"></span>
                                        {{ item.label }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-md-12 px-1 mb-2">
                        <div class="row text-center">
                            <div class="py-2 px-3">
                                <div class="bg-main">
                                    <span class="text-white fw-semibold">OTROS</span>
                                </div>
                            </div>
                        </div>
                        <div class="row py-2 px-1 pt-0">
                            <div class="col-md-12 mt-2 align-left" v-for="(item2, index) in postAnestecia.others" :key="index">
                                <div class="form-group d-md-flex">
                                    <label :for="'others' + index" class="col-xl-4 col-lg-4 col-md-4 col-sm-12 color-main fw-semibold">{{
                                            item2.label }}</label>
                                    <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12">
                                        <input type="text" v-model="item2.value" disabled class="form-control form-control-input form-control-sm" :id="'others' + index" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="panel-border my-1">
                <!-- Terapia -->
                <div class="col-md-12 mb-2">
                    <div class="row mb-2">
                        <div class="col text-center fw-bold py-2 div-title">
                            <span class="text-uppercase">Terapeutico Proporcionado</span>
                        </div>
                    </div>

                    <div class="mt-2">
                        <ul class="list-group text-xs">
                            <li class="list-group-item" v-for="(item, index) in cpRecipe" :key="index">
                                <span>{{ index + 1 }}. {{ item.molecule }} - {{ item.dosis }} - {{
                                        item.presentation }} - {{ mtdIndicacion(item) }}</span>
                            </li>
                            <li class="list-group-item mb-2" v-if="cpRecipe.length == 0">
                                No se han registrado receta
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="panel-border my-1">
                <!-- Evaluacion a su egreso -->
                <div class="col-md-12 pb-2">
                    <div class="row mb-2">
                        <div class="col text-center fw-bold py-2 div-title">
                            <span class="text-uppercase">Evaluación a su egreso</span>
                        </div>
                    </div>
                    <div class="d-lg-flex gap-3 px-3">
                        <div class="col-lg-6 col-md-12">
                            <!-- Scores -->
                            <!-- score_aldrete -->
                            <div class="row px-2 text-center">
                                <div class="py-2 px-3">
                                    <div class="bg-main">
                                        <span class="text-white fw-semibold ">SCORE ALDRETE</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row d-flex py-1 px-3 pt-0">
                                <div class="col-12" v-for="(item, index) in postAnestecia.score_aldrete_expense" :key="index">
                                    <div class="d-md-flex text-xs">
                                        <div class="col-lg-8 col-md-7 align-left">
                                            <span class="fw-semibold color-main">{{ item.label }}</span>
                                        </div>
                                        <div class="col-lg-4 col-md-5 d-flex justify-content-center">
                                            <span class="text-md">{{ item.value }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 my-2">
                                    <div class="d-md-flex px-1">
                                        <div class="col-lg-6 col-md-6 align-left">
                                            <label for="totalsae" class="fw-bold color-main ">Total: </label>
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <input class="form-control form-control-sm form-control-input" type="text" name="total" id="totalsae" v-model="cpTotalScoreAldreteExpense" disabled>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- score_aldrete -->
                            <div class="row px-2 text-center">
                                <div class="py-2 px-3">
                                    <div class="bg-main">
                                        <span class="text-white fw-semibold ">SCORE STEWARD</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row d-flex p-1 pt-0">
                                <div class="col-12" v-for="(item, index) in postAnestecia.score_steward_expense">
                                    <div class="d-md-flex text-xs px-2">
                                        <div class="col-lg-8 col-md-7 align-left">
                                            <span class="fw-semibold color-main">{{ item.label }}</span>
                                        </div>
                                        <div class="col-lg-4 col-md-5 d-flex justify-content-center">
                                            <span class="text-md">{{ item.value }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 my-2">
                                    <div class="d-md-flex px-1">
                                        <div class="col-lg-6 col-md-6 align-left">
                                            <label for="totalsse" class="fw-bold color-main ">Total: </label>
                                        </div>
                                        <div class="col-lg-6 col-md-6">
                                            <input class="form-control form-control-sm form-control-input" type="text" name="total" id="totalsse" v-model="cpTotalStewardExpense" disabled>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- score_bromage -->
                            <div class="row px-2 text-center">
                                <div class="py-2 px-3">
                                    <div class="bg-main">
                                        <span class="text-white fw-semibold ">SCORE BROMAGE</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row d-flex p-1 pt-0">
                                <div class="col-12" v-for="(item, index) in postAnestecia.score_bromage_expense">
                                    <div class="d-md-flex text-xs px-1">
                                        <div class="col-lg-8 col-md-7 align-left">
                                            <span class="fw-semibold color-main">{{ item.label }}</span>
                                        </div>
                                        <div class="col-lg-4 col-md-5">
                                            <div class="form-inline mx-1">
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" type="radio" disabled :name="'valorsbe' + index" :id="'d1sbe' + index" :value="0" v-model="item.value">
                                                    <label class="form-check-label text-md" :for="'d1sbe' + index">0</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" type="radio" disabled :name="'valorsbe' + index" :id="'d2sbe' + index" :value="1" v-model="item.value">
                                                    <label class="form-check-label text-md" :for="'d2sbe' + index">1</label>
                                                </div>
                                                <div class="form-check form-check-inline">
                                                    <input class="form-check-input" type="radio" disabled :name="'valorsbe' + index" :id="'d3sbe' + index" :value="2" v-model="item.value">
                                                    <label class="form-check-label text-md" :for="'d3sbe' + index">2</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-12 pb-3">
                            <div class="row mb-2">
                                <div class="col-md-12 mt-1 align-left">
                                    <div class="mb-1">
                                        <label for="tratamiento" class="fw-bold color-main">Ex. Auxiliares</label>
                                        <textarea class="form-control input-textarea" id="tratamiento" rows="2" style="resize: none;" v-model="postAnestecia.auxiliary_exams" disabled />
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-md-12 mt-1 align-left">
                                        <div class="mb-1">
                                            <label for="resultados" class="fw-bold color-main">Resultados</label>
                                            <textarea class="form-control input-textarea" id="resultados" rows="2"
                                                style="resize: none;" v-model="postAnestecia.results" disabled />
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-md-12 mt-1 align-left">
                                        <div class="mb-1">
                                            <label for="pendientes" class="fw-bold color-main">Pendientes</label>
                                            <textarea class="form-control input-textarea" id="pendientes" rows="2"
                                                style="resize: none;" v-model="postAnestecia.pending" disabled />
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-2">
                                    <div class="col-md-12 mt-1 align-left">
                                        <div class="mb-1">
                                            <label for="complicaciones"
                                                class="fw-bold color-main">Complicaciones</label>
                                            <textarea class="form-control input-textarea" id="complicaciones" rows="2"
                                                style="resize: none;" v-model="postAnestecia.complications" disabled />
                                        </div>
                                    </div>
                                </div>
                                <div class="row my-2">
                                    <div class="col-md-12 mt-1 align-left">
                                        <div class="mb-1">
                                            <label for="indicaciones" class="fw-bold color-main">Indicaciones
                                                Especiales</label>
                                            <textarea class="form-control input-textarea" id="indicaciones" rows="2"
                                                style="resize: none;" v-model="postAnestecia.special_indications" disabled />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="px-0" v-else>
            <div class="alert alert-info mt-3" role="alert">
                No se ha encontrado información
            </div>
        </div>
    </div>
</template>

<script>
import {
    mapActions
} from 'vuex';
export default {
    name: "ReportHojaAnestecia",
    data() {
        return {
            postAnestecia: {},
        };
    },
    watch: {
        medical_act_id: {
            immediate: true,
            handler: function (newValue) {
                if (newValue !== 0) {
                    this.mtdGetData();
                }
            }
        }
    },
    props: {
        medical_act_id: {
            type: Number,
        }
    },
    computed: {
        cpNurse() {
            return this.postAnestecia.nurse.name + " " + this.postAnestecia.nurse.last_name;
        },
        cpNurseCode() {
            return this.postAnestecia.nurse.cep;
        },
        cpRecipe() {
            return this.postAnestecia.recipe;
        },
        cpTotalScoreAldrete() {
            let tot = 0;
            this.postAnestecia.score_aldrete.forEach(element => {
                let value = element.value == "" || !element.value ? 0 : element.value;
                tot += parseInt(value);
            });
            return isNaN(tot) ? 0 : tot;
        },
        cpTotalScoreAldreteExpense() {
            let tot = 0;
            this.postAnestecia.score_aldrete_expense.forEach(element => {
                let value = element.value == "" || !element.value ? 0 : element.value;
                tot += parseInt(value);
            });
            return isNaN(tot) ? 0 : tot;
        },
        cpTotalSteward() {
            let tot = 0;
            this.postAnestecia.score_steward.forEach(element => {
                let value = element.value == "" || !element.value ? 0 : element.value;
                tot += parseInt(value);
            });
            return isNaN(tot) ? 0 : tot;
        },
        cpTotalStewardExpense() {
            let tot = 0;
            this.postAnestecia.score_steward_expense.forEach(element => {
                let value = element.value == "" || !element.value ? 0 : element.value;
                tot += parseInt(value);
            });
            return isNaN(tot) ? 0 : tot;
        },
    },
    methods: {
        ...mapActions(["get", "post"]),
        mtdGetData: function () {
            this.get({
                    url: this.$store.getters.get__url + "/Sop/indexPostAnestecia/" + this.medical_act_id,
                    token: this.$store.getters.get__token,
                })
                .then((response) => {
                    let data = response.data;
                    if (data) {
                        this.postAnestecia = data;
                    }
                })
                .catch((errors) => {
                    console.log(errors);
                });
        },
        mtdIndicacion(item) {
            let frequency = item.frequency;
            let duration = item.duration;
            let msg = frequency == 1 ? ' hora  x' : ' horas x';
            let msgduration = duration == 1 ? ' dia' : ' días';
            let msgfinal = "( cada " + frequency + msg + " " + duration + " " + msgduration + " )";
            return msgfinal.toUpperCase();
        },
        mtdViewPdf: function(){
            let ruta = "/viewpdfReportSop/postAnestesia/" + this.medical_act_id; 
            window.open(this.$store.getters.get__url + ruta, "_blank");

        }
    }
};
</script>
